import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { Color } from 'src/theme/color';
import { getTransparent } from '../../../utils/themer';

interface IPill {
	isCompleted?: boolean;
}

interface IOnboardingBar {
	completionCount: number;
}

export const OnboardingBar = ({ completionCount = 0 }: IOnboardingBar) => {
	const pills: IPill[] = [
		{
			isCompleted: completionCount >= 1,
		},
		{
			isCompleted: completionCount >= 2,
		},
		{
			isCompleted: completionCount >= 3,
		},
		{
			isCompleted: completionCount >= 4,
		},
	];

	return (
		<Flex
			gridGap="8px"
			alignItems="center"
			display={{ base: 'none', hashup: 'flex' }}
		>
			{pills.map((pill, index) => (
				<Pill
					key={`${pill}_${index}`}
					{...pill}
				/>
			))}
		</Flex>
	);
};

const Pill = ({ isCompleted = false }: IPill) => (
	<Box
		background={isCompleted ? Color.ACTION : 'background'}
		border="1px solid"
		borderColor={isCompleted ? 'action' : getTransparent(Color.TEXT, 50)}
		borderRadius="4px"
		height="4px"
		width={{ base: '100%', xl: '62px' }}
	/>
);
